import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e9e570f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "is-nav" }
const _hoisted_2 = { class: "home_contents_wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "home_layout_readmore"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 1,
  class: "home_layout_readmore"
}
const _hoisted_6 = ["onClick"]

import ApplyOrders from '@/components/ApplyOrders.vue';
import RecommendOrders from '@/components/RecommendOrders.vue';
import { computed } from 'vue';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const store = useStore();

const appliedTotal = computed(() => {
  return store.getters['applyOrder/total'];
});

const recommendTotal = computed(() => {
  return store.getters['recommendOrder/total'] as number;
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ApplyOrders, {
        class: "is-home",
        limit: 4
      }),
      (_unref(appliedTotal) > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_router_link, { to: { name: 'j00' } }, {
              default: _withCtx(({ navigate }) => [
                _createElementVNode("button", {
                  class: "button_read_more",
                  onClick: navigate
                }, "もっと見る", 8, _hoisted_4)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createVNode(RecommendOrders, { "continue-btn-disable": true }),
      (_unref(recommendTotal) > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_router_link, { to: { name: 'l00' } }, {
              default: _withCtx(({ navigate }) => [
                _createElementVNode("button", {
                  class: "button_read_more",
                  onClick: navigate
                }, "もっと見る", 8, _hoisted_6)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})